<template>
  <modelframe :message="message">
    <div class="model_param">
      <span class="param_title">基础参数</span>
      <div class="line"></div>
      <div class="model_item">
        <span>{{paramList.current.name}}</span>
        <select v-model="data.current">
          <option value="">请选择</option>
          <option v-for="(item,index) in paramList.current.value" :key="index">{{item}}</option>
        </select>
      </div>
      <div class="model_item">
        <span>{{paramList.short_current.name}}</span>
        <select v-model="data.short_current">
          <option value="">请选择</option>
          <option v-for="(item,index) in paramList.short_current.value" :key="index">{{item}}</option>
        </select>
      </div>
      <div class="model_item">
        <span>{{paramList.voltage.name}}</span>
        <select v-model="data.voltage">
          <option value="">请选择</option>
          <option v-for="(item,index) in paramList.voltage.value" :key="index">{{item}}</option>
        </select>
      </div>
    </div>
    <div class="info">
      <div>
        <img src="../assets/img/p0.png" alt="">
        <span>提示：</span>
        <span>1.结构形式：双卫开式</span>
        <span>2.分闸限位角度：完善化-160°</span>
      </div>
    </div>
    <div class="model_param">
      <span class="param_title">材质</span>
      <div class="line"></div>
      <div class="model_item">
        <span>{{paramList.material_copper.name}}</span>
        <select v-model="data.material_copper">
          <option value="">请选择</option>
          <option v-for="(item,index) in paramList.material_copper.value" :key="index">{{item}}</option>
        </select>
      </div>
      <div class="model_item">
        <span>{{paramList.surface_copper.name}}</span>
        <select v-model="data.surface_copper">
          <option value="">请选择</option>
          <option v-for="(item,index) in paramList.surface_copper.value" :key="index">{{item}}</option>
        </select>
      </div>
      <div class="model_item">
        <span>{{paramList.material_insulation.name}}</span>
        <select v-model="data.material_insulation">
          <option value="">请选择</option>
          <option v-for="(item,index) in paramList.material_insulation.value" :key="index">{{item}}</option>
        </select>
      </div>
      <div class="model_item">
        <span>{{paramList.material_base.name}}</span>
        <select v-model="data.material_base">
          <option value="">请选择</option>
          <option v-for="(item,index) in paramList.material_base.value" :key="index">{{item}}</option>
        </select>
      </div>
    </div>
    <div class="model_param">
      <span class="param_title">其他</span>
      <div class="line"></div>
      <div class="model_item">
        <span>{{paramList.altitude.name}}</span>
        <select v-model="data.altitude">
          <option value="">请选择</option>
          <option v-for="(item,index) in paramList.altitude.value" :key="index">{{item}}</option>
        </select>
      </div>
      <div class="model_item">
        <span>{{paramList.insulation_bracke.name}}</span>
        <select v-model="data.insulation_bracke">
          <option value="">请选择</option>
          <option v-for="(item,index) in paramList.insulation_bracke.value" :key="index">{{item}}</option>
        </select>
      </div>
      <div class="model_item">
        <span>{{paramList.standard_part.name}}</span>
        <select v-model="data.standard_part">
          <option value="">请选择</option>
          <option v-for="(item,index) in paramList.standard_part.value" :key="index">{{item}}</option>
        </select>
      </div>
    </div>
    <el-row class="submit">
      <el-button type="primary" @click="submit">提交</el-button>
      <el-button type="info" @click="clear">重置</el-button>
    </el-row>
  </modelframe>
</template>

<script>
export default {
  name: `modelparam`,
  data(){
    return {
      paramList:{
        current: {name:'',value:''},
        short_current: {name:'',value:''},
        voltage: {name:'',value:''},
        material_copper: {name:'',value:''},
        surface_copper: {name:'',value:''},
        material_insulation: {name:'',value:''},
        material_base: {name:'',value:''},
        altitude: {name:'',value:''},
        insulation_bracke: {name:'',value:''},
        standard_part: {name:'',value:''},
      },
      data:{
        current:'',
        short_current:'',
        voltage:'',
        material_copper:'',
        surface_copper:'',
        material_insulation:'',
        material_base:'',
        altitude:'',
        insulation_bracke:'',
        standard_part:'',
      },
      message:{
        code:1,
        msg:''
      }
    }
  },
  methods:{
    submit(){
      this.setMessage(1);//设置Loading
      this.axios.post('http://101.133.156.109:81/api/Model/postModel',
          {input:this.data,type:this.modelType}).then(
              (res)=>{
                // console.log('产品查询---'+res)
                let data = res.data
                if(data.status){
                  this.setMessage(2,'提交模型参数成功');
                }else{
                  this.setMessage(-1,data.msg);
              }}
          ).catch((error)=>{
              this.setMessage(-1,'请求数据失败,错误信息：'+error);
          });
    },
    clear(){
      Object.keys(this.data).forEach(key => this.data[key]='');//遍历对象，清空属性值
    },
    setMessage(code,msg){
      this.message.code =code;
      this.message.msg =msg;
    }
  },
  computed:{
    modelType(){
      return this.$route.query.type;
    }
  },

  watch:{
    modelType:{
      immediate:true,
      handler(){
        this.setMessage(1);//设置Loading
        this.axios.get('http://101.133.156.109:81/api/Model/model?modeltype='+this.modelType).then((res)=>{
          let data = res.data
          // console.log('监听数据'+data)
          if(data.status){
            this.paramList=JSON.parse(data.data);
            this.setMessage(0);
          }else{
            this.setMessage(-1,data.msg);
          }
        }).catch((error)=>{
          this.setMessage(-1,'请求数据失败,错误信息：'+error);
        });
      }
    }

  }
}
</script>

<style scoped>

.submit{
  text-align: center;
  margin-bottom: 30px;
}
.submit .el-button{
  margin: 15px;
}

img{
  width: 198px;
  height: 135px;
  margin-bottom: 1rem;
}
.info{
  left: 787px;
  top: 0;
  width: calc(100% - 787px);
  height: 100%;
  font-size: 12px;
  color: #7F7F7F;
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  position: absolute;
}
.info > div{
  margin-top:20px ;
  margin-left: 40px;
  position: relative;

}
.info  span{
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  line-height: normal;
  display: list-item;
  list-style: none;
}
.model_param{
  width: 787px;
  margin-top: 1.5rem;
  height: 14rem;
}
.param_title{
  margin-top:14px ;
  margin-left: 15px;
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑, sans-serif;
  font-weight: 700;
  font-style: normal;
  color: rgb(26, 188, 156);
}
.line{
  width: 787px;
  height: 1px;
  background-color: #797979;
}
.model_item{
  text-align: right;
  padding-right: 0;
  display: flex;
  justify-self:right;
  margin: 2rem;
  width: 300px;
  float: left;
  position: relative;
}
.model_item:nth-of-type(odd){
  right: 2rem;
  float: right;
}
.model_item > span {
  font-family: "微软雅黑 Light", "微软雅黑 Regular", 微软雅黑, sans-serif;
  font-weight: 250;
  font-style: normal;
  color: rgb(102, 102, 102);
  text-align: right;
  position: absolute;
  width: fit-content;
  right: 240px;
}
.model_item > select{
  position: absolute;
  width: 160px;
  right: 75px;
}
.model_param:last-child  .model_item:last-child > select{
  right: -25px;
  width: 260px;
}


</style>
